import repository from '@/utils/repository';

export default {
    PopupChangePassWordMNG: (data) => {
        return repository.post(`/move/change-password-mng`, {
            ...data
        });
    },
    PopupChangePassWordCUS: (data) => {
        return repository.post(`/move/change-password-cus`, {
            ...data
        });
    }
};
